import React from "react";
import { Modal, Button, Input, Form } from "antd";
const { Item } = Form;

function AddWalletAddress(props) {
    const {
        visibleExchangeRateWallet,
        leaveAddWallet,
        exchangeRateWalletTest,
        handleOk,
        addTDBBtnStatue,
        tDBName,
        tDBAddress,
        tDBAddressError,
        tDBNameError,
        tDBAddressError2,
    } = props;
    const isErc = props.ctcMethod === "USDT-ERC20";
    return (
        <Modal
            title={"添加 " + props.ctcMethod + " 钱包地址"}
            visible={visibleExchangeRateWallet}
            onCancel={leaveAddWallet}
            footer={null}
            className="addExchangeRateWalletModal"
            width={400}
        >
            <Form className="WalletModal-form-wrap">
                <Item label="钱包名称">
                    <Input
                        size="large"
                        className="tlc-input-disabled"
                        placeholder="请输入名称"
                        onChange={(e) => exchangeRateWalletTest(e, "name")}
                        maxLength={20}
                        value={tDBName}
                    />
                    {/* {!tDBNameError && tDBName != '' && <p className='errorTip'>格式错误</p>} */}
                    <div className="modal-wallet-info">
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBNameError ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        不允许使用特殊字符
                    </div>
                    <div className="modal-wallet-info">
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBName ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        最多20个字符
                    </div>
                </Item>
                <Item label="钱包地址">
                    <Input
                        size="large"
                        className="tlc-input-disabled"
                        placeholder="请输入地址"
                        onChange={(e) =>
                            exchangeRateWalletTest(
                                e,
                                "address",
                                props.ctcMethod
                                // ^ It looks this 3rd parameter is useless.
                            )
                        }
                        maxLength={isErc ? 42 : 34}
                        value={tDBAddress}
                    />
                    {/* {!tDBAddressError && tDBAddress != '' && <p className='errorTip'>格式错误</p>} */}
                    <div className="modal-wallet-info">
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBAddressError2 ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        不允许使用空格和特殊字符
                    </div>
                    <div className="modal-wallet-info">
                        <img
                            style={{ marginRight: "0.4rem" }}
                            src={`/cn/img/icon/${
                                !tDBAddressError ? "greyTick" : "greenTick"
                            }.svg`}
                        />
                        {isErc
                            ? "以”0x”开头, 为一串42个字母数字字符"
                            : '以"T"开头, 为一串34个字母数字字符'}
                    </div>
                </Item>
                <Item>
                    <div className="btn-wrap">
                        {/* <Button size="large" htmlType="submit" block onClick={leaveAddWallet}>取消</Button> */}
                        <Button
                            size="large"
                            htmlType="submit"
                            block
                            onClick={handleOk}
                            disabled={!addTDBBtnStatue}
                            className={`${addTDBBtnStatue ? "active" : ""}`}
                        >
                            添加
                        </Button>
                    </div>
                </Item>
            </Form>
        </Modal>
    );
}

export default AddWalletAddress;
